export enum PageType {
  // Market + Predict pages
  GLOBAL_SUMMARY,
  PRODUCTS,
  SEGMENTATION,
  PRODUCT,
  REVENUE_PREMIUM,
  CONVERSION_OPPORTUNITIES,
  PURCHASE_FUNNEL,
  CONSUMER_PERCEPTION,
  PROMOTION_PLANNER,
  BRAND,
  FORECASTING,
  RECOMMENDATIONS,
  OVERVIEW,
  PERFORMANCE_DRIVERS,
  PRICE_PLANNER,
  PROMOTION_HISTORY,
  // Retail pages
  CATEGORY_LEADERBOARD,
  RETAILER_OVERVIEW,
  OPPORTUNITY_REVIEW,
  PERFORMANCE_ANALYSIS,
  TRADING_ASSISTANT,
  PRODUCT_ANALYZER,
  // Market pages
  MARKET_OVERVIEW,
}

export enum MarketPageType {
  MARKET_OVERVIEW,
}

export enum RetailPageType {
  CATEGORY_LEADERBOARD,
  RETAILER_OVERVIEW,
  OPPORTUNITY_REVIEW,
  PERFORMANCE_ANALYSIS,
  RI_PRODUCT,
  TRADING_ASSISTANT,
}

export type Page = {
  title: string;
  type: PageType;
  path?: string | string[];
  match?: RegExp;
};

export type NotificationMessage = {
  message: string;
  type: NotificationToastType;
  timeout?: number;
};

export enum NotificationToastType {
  Success = 'success',
  Error = 'error',
  Info = 'info',
  Warn = 'warn',
}
